"use client";

import type { ReactNode } from "react";
import { useRef } from "react";
import { Provider } from "@ai-sdk-tools/store";
import { ArtifactsProvider } from "@/components/artifacts-provider";

type Props = {
  initialMessages: unknown;
  children: ReactNode;
};

export function ChatStoreProvider({ initialMessages, children }: Props) {
  // Provider expects UIMessage[]
  const safeInitial = Array.isArray(initialMessages) ? initialMessages : [];
  // IMPORTANT:
  // `@ai-sdk-tools/store` Provider can treat `initialMessages` as a seed and
  // re-apply it when the prop identity changes (e.g. server re-renders),
  // which wipes the live chat state. We only want to seed once per mount.
  // Route changes already remount this provider via the `key` in `page.tsx`.
  const seededInitialRef = useRef(safeInitial);

  return (
    <Provider initialMessages={seededInitialRef.current as any}>
      <ArtifactsProvider>{children}</ArtifactsProvider>
    </Provider>
  );
}

